import {CSSProperties, FC} from 'react'
import ClipLoader from 'react-spinners/ClipLoader'

interface ISpinnerProps {
  size?: number
  color?: string
  loading?: boolean
}

const cssOverride: CSSProperties = {
  // display: 'block',
  // margin: '0 auto',
  // borderColor: 'red',
  borderWidth: 4,
  pointerEvents: 'none',
  userSelect: 'none',
}

const Spinner: FC<ISpinnerProps> = ({size = 35, color = '#ffffff', loading = true}) => {
  return (
    <ClipLoader
      color={color}
      loading={loading}
      cssOverride={cssOverride}
      size={size}
      aria-label="Spinner"
      data-testid="spinner"
    />
  )
}

export default Spinner
